var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ps-product--detail ps-product--quickview"},[_c('div',{staticClass:"ps-product__header"},[_c('thumbnail-quick-view',{attrs:{"product":_vm.product}}),_vm._v(" "),_c('information-quick-view',{attrs:{"product":_vm.product}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }